export default "__VITE_ASSET__DIlkw_kA__"